import React from 'react';
import dayjs from 'dayjs';
import DataGrid from '../../../../common/DataGrid/DataGrid';
import { useTranslation } from 'react-i18next';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter';
import { IconButton } from '../../../../common/controls/Controls';
import { DownloadOutlined } from '@ant-design/icons';

const PhdDissertationDefenseApplicationsTable = ({
  applications,
  onDetailClick,
  onDelete,
  onDownload,
  isDownloading = false,
  canDeleteSubmitted = false,
  pagination,
  onPaginationChange,
}) => {
  const { t } = useTranslation();

  const studentFilter = useDataGridTextFilter('student_display_name');
  const supervisorFilter = useDataGridTextFilter('supervisor_display_name');
  const updatedByFilter = useDataGridTextFilter('updated_by_name');

  const columns = [
    {
      title: t('Študent'),
      dataIndex: 'student_display_name',
      key: 'student_display_name',
      ellipsis: true,
      ...studentFilter,
    },
    {
      title: t('Školiteľ'),
      dataIndex: 'supervisor_display_name',
      key: 'supervisor_display_name',
      ellipsis: true,
      ...supervisorFilter,
    },
    {
      title: t('Naposledy upravené'),
      dataIndex: 'updated_at',
      key: 'updated_at',
      ellipsis: true,
      render: (value) =>
        value ? dayjs(value).format('DD.MM.YYYY HH:mm') : '—',
    },
    {
      title: t('Upravil'),
      dataIndex: 'updated_by_name',
      key: 'updated_by_name',
      ellipsis: true,
      render: (value) => value || '—',
      ...updatedByFilter,
    },
  ];

  const customSettings = (row) => (
    <IconButton
      icon={<DownloadOutlined />}
      tooltip={t('Stiahnuť DOCX')}
      disabled={Boolean(!onDownload || isDownloading || !row?.is_frozen)}
      disabledTooltip={
        !onDownload
          ? t('Sťahovanie nie je dostupné')
          : !row?.is_frozen
            ? t('Dokument ešte nemá zmrazenú archívnu verziu')
          : isDownloading
            ? t('Dokument sa práve generuje')
            : undefined
      }
      onClick={(e) => {
        e.stopPropagation();
        if (!onDownload || isDownloading || !row?.is_frozen) {
          return;
        }
        onDownload(row);
      }}
    />
  );

  return (
    <DataGrid
      locale={{
        emptyText: t(
          'Pre zvolený pohľad a filtre nie sú dostupné žiadne záznamy.',
        ),
      }}
      rowKey={(application) => application.id}
      columns={columns}
      dataSource={applications || []}
      permissionsBasic={'phd-dissertation-defense-applications'}
      uniqueTableId={'phd-dissertation-defense-applications-table'}
      customSettings={customSettings}
      onEditClick={onDetailClick}
      onRowClick={onDetailClick}
      onDelete={onDelete}
      secondaryCondition={(row) => row.can_edit !== false}
      deleteCondition={(row) =>
        row.can_delete !== false && (canDeleteSubmitted || !row?.submitted_at)
      }
      editDisabledTooltip={t('Archivovaný záznam je iba na čítanie')}
      deleteDisabledTooltip={(row) =>
        row.is_read_only
          ? t('Archivovaný záznam nie je možné vymazať')
          : t('Odovzdanú prihlášku nie je možné vymazať')
      }
      pagination={pagination}
      onChange={onPaginationChange}
    />
  );
};

export default PhdDissertationDefenseApplicationsTable;
